export const GET_DIGITALMENUS = "GET_DIGITALMENUS";
